<template>
  <side-nav-section
    :active="$route.name.includes('reward')"
    :user="user"
    :section="consts.SIDENAV_REWARDS_SECTION"
    :stat="statTotal"
    :notification="hasNotification"
  >
    <side-nav-item :item="consts.SIDENAV_REWARDS_WON_ROUTE">
      <span class="number" v-if="user.rewards_won_count">{{
        user.rewards_won_count
      }}</span>
    </side-nav-item>
    <side-nav-item :item="consts.SIDENAV_REWARDS_LEADERBOARD_ROUTE">
      <span class="number" v-if="user.rewards_leaderboard_count">{{
        user.rewards_leaderboard_count
      }}</span>
    </side-nav-item>
    <side-nav-item :item="consts.SIDENAV_REWARDS_POTENTIAL_ROUTE" />
  </side-nav-section>
</template>

<script>
import {
  SIDENAV_REWARDS_SECTION,
  SIDENAV_REWARDS_LEADERBOARD_ROUTE,
  SIDENAV_REWARDS_POTENTIAL_ROUTE,
  SIDENAV_REWARDS_WON_ROUTE,
} from "Consts/sideNav/rewardsSection";
import SideNavSection from "Public/components/SideNav/SideNavSections/SideNavSection";
import SideNavItem from "Public/components/SideNav/SideNavItem";
export default {
  name: "RewardsSection",
  components: { SideNavItem, SideNavSection },
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  computed: {
    statTotal() {
      return this.user.rewards_won_count + this.user.rewards_leaderboard_count;
    },
    hasNotification() {
      return !!this.statTotal;
    },
  },
  data() {
    return {
      consts: {
        SIDENAV_REWARDS_SECTION,
        SIDENAV_REWARDS_POTENTIAL_ROUTE,
        SIDENAV_REWARDS_WON_ROUTE,
        SIDENAV_REWARDS_LEADERBOARD_ROUTE,
      },
    };
  },
};
</script>

<style scoped></style>
